import { defineComponent as _defineComponent } from 'vue'
import { computed, ref } from 'vue'
import { sortBy } from 'lodash'
import { useGetLocationStatusesQuery } from '@/api/locations'
import VsWrapper from '@/components/vision/VsWrapper.vue'
import AutoComplete from '@/components/common/AutoComplete.vue'
import VsTextInput from '@/components/vision/Inputs/VsTextInput.vue'
import NewLocationPicker from '@/components/locations/NewLocationPicker.vue'
import RemovableRow from '@/components/common/RemovableRow.vue'
import NewTag from '@/models/new_tag'
import TagsEditor from '@/components/common/tags/TagsEditor.vue'
import VsHeading from '@/components/vision/VsHeading.vue'
import VsText from '@/components/vision/VsText.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'OnTheFlyLocationOptionalFields',
  props: {
    showParentLocationField: { type: Boolean },
    showDescriptionField: { type: Boolean },
    showStatusField: { type: Boolean },
    showTagsField: { type: Boolean },
    parentId: null,
    description: null,
    colorId: null
  },
  emits: ['tags-input'],
  setup(__props: any, { emit }) {

const props = __props as {
  showParentLocationField: boolean
  showDescriptionField: boolean
  showStatusField: boolean
  showTagsField: boolean
  parentId?: number | null
  description?: string | null
  colorId?: number | null
}


const { data: locationStatuses } = useGetLocationStatusesQuery()
const statuses = computed(() => {
  return sortBy(
    locationStatuses.value?.map((ls) => ({
      text: ls.name,
      value: ls.id,
      color: ls.hexCode,
    })),
    'text'
  )
})

const showTagsErrorMessage = ref(false)
const tagsErrorMessage = ref<string | null>(null)

const handleTagUpdate = (e: NewTag[]) => {
  emit('tags-input', e)
  showTagsErrorMessage.value = false
}
const handleTagsError = (err: string | null) => {
  tagsErrorMessage.value = err
  showTagsErrorMessage.value = true
  setTimeout(() => {
    showTagsErrorMessage.value = false
  }, 5000)
}

return { __sfc: true,props, locationStatuses, statuses, showTagsErrorMessage, tagsErrorMessage, emit, handleTagUpdate, handleTagsError, VsWrapper, AutoComplete, VsTextInput, NewLocationPicker, RemovableRow, TagsEditor, VsHeading, VsText }
}

})